import classJoin from 'classjoin';
import {Component, h} from 'preact';

/**
 * Component Properties.
 */
interface NumberScrollProps
{
	/**
	 * Минимальное число.
	 */
	min: number;
	/**
	 * Максимальное число.
	 */
	max: number;
	/**
	 * Текущее значение.
	 */
	value: number;
	/**
	 * Количество отображаемых шагов в стороны от текущего значения.
	 */
	steps?: number;
	/**
	 * Обработчик изменения значения.
	 * 
	 * @param value Новое значение.
	 */
	onChange( value: number ): void;
}

/**
 * Component State.
 */
interface NumberScrollState
{
	[key: string]: void;
}

/**
 * Компонент прокрутки номера в заданном диапазоне.
 */
class NumberScroll extends Component<NumberScrollProps, NumberScrollState>
{
	/**
	 * Default properties of the component.
	 */
	public static defaultProps: Partial<NumberScrollProps> = {
		steps: 2,
	};
	
	/**
	 * Render component.
	 */
	public render( {min, max, value}: NumberScrollProps ): JSX.Element
	{
		const items = this.getValueRange();
		
		return (
			<div class="number-scroll">
				<button
					type="button"
					class="back"
					disabled={value === min}
					onClick={this.onBackClick}
				>
					Назад
				</button>
				<ul onClick={this.onItemsClick}>
					{items.map(
						( item ) => (
							<li
								class={classJoin( {current: ( value === item )} )}
								data-value={item}
							>
								{item}
							</li>
						),
					)}
				</ul>
				<button
					type="button"
					class="forward"
					disabled={value === max}
					onClick={this.onForwardClick}
				>
					Вперёд
				</button>
			</div>
		);
	}
	
	/**
	 * При нажатии на элемент списка.
	 */
	private onItemsClick = ( event: Event ): void =>
	{
		const target = event.target as HTMLElement;
		
		if ( target.tagName !== 'LI' )
		{
			return;
		}
		
		const value = Number( target.dataset.value );
		
		if ( !isNaN( value ) )
		{
			this.props.onChange( value );
		}
	}
	
	/**
	 * При нажатии на «Назад»
	 */
	private onBackClick = (): void =>
	{
		const nextValue = this.props.value - 1;
		
		if ( nextValue >= this.props.min )
		{
			this.props.onChange( nextValue );
		}
	}
	
	/**
	 * При нажатии на Вперёд
	 */
	private onForwardClick = (): void =>
	{
		const nextValue = this.props.value + 1;
		
		if ( nextValue <= this.props.max )
		{
			this.props.onChange( nextValue );
		}
	}
	
	/**
	 * Получить видимый диапазон цифр для текущего значения.
	 */
	private getValueRange(): number[]
	{
		const {min, max, value} = this.props;
		const steps = this.props.steps || 2;
		const values: number[] = [];
		
		let from: number = value - steps;
		let to: number = value + steps;
		
		if ( from < min )
		{
			to += min - from;
			from = min;
		}
		
		if ( to > max )
		{
			from += max - to;
			to = max;
		}
		
		if ( from < min )
		{
			from = min;
		}
		
		for ( let i = from; i <= to; i++ )
		{
			values.push( i );
		}
		
		return values;
	}
}

/**
 * Module.
 */
export {
	NumberScroll as default,
	NumberScrollProps,
	NumberScrollState,
};



// WEBPACK FOOTER //
// ./app/Routes/Choose/App/NumberScroll.tsx